function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { FormProvider, useForm } from 'react-hook-form';
import { ConfirmationModal, FullColumn } from 'seagull';
import ServiceDescription from "../ServiceCreation/ServiceBuilder/ServiceDescription";
import ServiceNameTextField from "../ServiceCreation/ServiceBuilder/ServiceNameTextField";
import { EditServiceContentModalTestIds } from "./EditServiceContentModal.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EditServiceContentModal = _ref => {
  let {
    serviceName,
    description,
    title,
    width,
    dismissModal,
    onSave,
    serviceNameBlacklist
  } = _ref;
  const form = useForm({
    defaultValues: {
      serviceName,
      description
    }
  });
  const onSubmit = data => {
    onSave({
      name: data.serviceName,
      description: data.description
    });
  };
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    width: width,
    "data-testid": EditServiceContentModalTestIds.EditServiceModal(),
    title: title,
    content: /*#__PURE__*/_jsx(FormProvider, _objectSpread(_objectSpread({}, form), {}, {
      children: /*#__PURE__*/_jsx("form", {
        onSubmit: form.handleSubmit(onSubmit),
        children: /*#__PURE__*/_jsxs(FullColumn, {
          gap: 24,
          children: [/*#__PURE__*/_jsx(ServiceNameTextField, {
            testid: EditServiceContentModalTestIds.EditServiceNameInput(),
            serviceNameBlacklist: serviceNameBlacklist
          }), /*#__PURE__*/_jsx(ServiceDescription, {
            testId: EditServiceContentModalTestIds.EditServiceDescriptionInput()
          })]
        })
      })
    })),
    onPrimaryButtonClick: form.handleSubmit(onSubmit),
    onSecondaryButtonClick: () => dismissModal(),
    primaryButtonLabel: "Save",
    secondaryButtonLabel: "Cancel",
    primaryButtonTestid: EditServiceContentModalTestIds.EditServiceModalSaveButton()
  });
};
export default EditServiceContentModal;